const LINKS = [
  // {
  //   title: "Dashboard",
  //   icon: "calendar",
  //   pages:
  //       [
  //     {
  //       title: "Dashboard",
  //       path: "/dashboard", // Placeholder link
  //     },
  //     {
  //       title: "Blankett",
  //       path: "/match-summary", // Placeholder link
  //     },
  //   ],
  // },
  {
    title: "Mannschaft",
    icon: "users",
    pages: [
      {
        title: "Kader",
        path: "/kader", // Placeholder link
      },
      {
        title: "Spielplan",
        path: "/kader/matches", // Placeholder link
      },
      {
        title: "Spieler Anmelden",
        path: "/kader/spieler-anmelden", // Placeholder link
      },
      {
        title: "Trainer",
        path: "/kader/trainer-anmelden",
      },
      // {
      //   title: "Kapitan wechseln",
      //   path: "/blank", // Placeholder link
      // },
      // {
      //   title: "Rückennummern",
      //   path: "/blank", // Placeholder link
      // },
    ],
  },
  {
    title: "Transfers",
    icon: "users",
    pages: [
      {
        title: "Meine Transfers",
        path: "/transfer/index",
      },
      {
        title: "Spieler",
        path: "/transfer/players",
      },
    ],
  },
  {
    title: "Office Bereich",
    icon: "envelope",
    pages: [
      {
        title: "Chat",
        path: "/office/inbox",
      },
      {
        title: "Finanzen",
        path: "/office/finanzen",
      },
      {
        title: "Ligaordnung",
        path: "https://oekfb.eu/ligaordnung",
      },
      {
        title: "Kontakt Daten",
        path: "/office/kontakt-daten",
      },
      // {
      //   title: "Vertrag",
      //   path: "/office/vertrag", // Placeholder link
      // },
      // {
      //   title: "Tutorial",
      //   path: "/blank", // Placeholder link
      // },
    ],
  },
];

export default LINKS;
